import { Theme } from "@mui/material";

export const getNumberFieldStyles = (theme: Theme, invalid = false) => ({
  field: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: theme.spacing(0.5),
  } satisfies React.CSSProperties,

  label: {
    cursor: "ew-resize",
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
  } satisfies React.CSSProperties,

  group: {
    display: "flex",
  } satisfies React.CSSProperties,

  input: {
    boxSizing: "border-box" as const,
    margin: 0,
    padding: 0,
    borderRadius: 0,
    borderTop: `1px solid ${
      invalid ? theme.palette.error.main : theme.palette.divider
    }`,
    borderBottom: `1px solid ${
      invalid ? theme.palette.error.main : theme.palette.divider
    }`,
    borderLeft: "none",
    borderRight: "none",
    width: "6rem",
    height: "2.5rem",
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    textAlign: "center" as const,
    fontVariantNumeric: "tabular-nums",
    outline: "none",
  } satisfies React.CSSProperties,

  decrementIncrementBase: {
    boxSizing: "border-box" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "2.5rem",
    height: "2.5rem",
    margin: 0,
    outline: 0,
    padding: 0,
    border: `1px solid ${
      invalid ? theme.palette.error.main : theme.palette.divider
    }`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover,
    color: invalid ? theme.palette.error.main : theme.palette.text.primary,
    userSelect: "none" as const,
    cursor: "pointer",
  } satisfies React.CSSProperties,

  error: {
    position: "absolute",
    bottom: 0,
    color: theme.palette.error.main,
    fontSize: theme.typography.caption.fontSize,
  } satisfies React.CSSProperties,

  get decrement() {
    return {
      ...this.decrementIncrementBase,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    } satisfies React.CSSProperties;
  },

  get increment() {
    return {
      ...this.decrementIncrementBase,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    } satisfies React.CSSProperties;
  },
});
